var map = {
	"./auth.js": 59293,
	"./authservice.js": 63690,
	"./error.js": 773,
	"./layout.js": 97077,
	"./notification.js": 42368,
	"./paymentService.js": 63130,
	"./shopService.js": 54640,
	"./userService.js": 56837
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 70634;